import {useCallback, useEffect, useState} from 'react';

export const usePrefersReducedMotion = () => {
	const [hasReducedMotionPreference, setHasReducedMotionPreference] = useState(false);

	const listener = useCallback((event: MediaQueryListEvent) => {
		setHasReducedMotionPreference(event.matches);
	}, []);

	useEffect(() => {
		if (!window) {
			return;
		}

		const list = window.matchMedia('(prefers-reduced-motion: reduce)');

		list.addEventListener('change', listener);

		return () => {
			list.removeEventListener('change', listener);
		};
	}, [listener]);

	return hasReducedMotionPreference;
};
